import { actionTypes } from './constants';
import { createAsyncThunk } from '@reduxjs/toolkit';
import * as api from './api';
import * as T from './types';

export const fetchWidgetData = createAsyncThunk(
  actionTypes.FETCH_WIDGET_DATA,
  async ({ siteId, widgetId }: T.FetchWidgetApiPayload) =>
    await api.fetchWidgetDataApi({
      siteId,
      widgetId,
    }),
);

export const fetchWidgets = createAsyncThunk(
  actionTypes.FETCH_WIDGETS,
  async ({ siteId }: T.FetchWidgetsApiPayload) =>
    await api.fetchWidgetsApi({
      siteId,
    }),
);

export const createWidget = createAsyncThunk(
  actionTypes.CREATE_WIDGET,
  async ({ siteId, name, is_default }: T.CreateWidgetPayload) =>
    await api.createWidgetApi({
      siteId,
      name,
      is_default,
    }),
);

export const updateWidget = createAsyncThunk(
  actionTypes.UPDATE_WIDGET,
  async ({ siteId, widgetId, name, is_default }: T.UpdateWidgetPayload) =>
    await api.updateWidgetApi({
      siteId,
      widgetId,
      name,
      is_default,
    }),
);

export const deleteWidget = createAsyncThunk(
  actionTypes.DELETE_WIDGET,
  async ({ siteId, widgetId }: T.DeleteWidgetPayload) =>
    await api.deleteWidgetApi({
      siteId,
      widgetId,
    }),
);

export const duplicateWidget = createAsyncThunk(
  actionTypes.DUPLICATE_WIDGET,
  async ({ siteId, widgetId, name }: T.DuplicateWidgetPayload) =>
    await api.duplicateWidgetApi({
      siteId,
      widgetId,
      name,
    }),
);
